export default __webpack_public_path__ + "static/media/codex_connect_usb.b0d3c002.jpg";